module.exports = __webpack_public_path__ + "img/one_10.4b87a80d.png";